import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerPaymentBlockUpdateRequest } from '../models/models'

export class AddDealerBlockApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerInformation/updatePaymentBlockedDealers',
      requesterInfo,
    })
  }

  public async AddDealerBlock(dealerBlock: IDealerPaymentBlockUpdateRequest[]): Promise<any> {
    return await this.postAsync<IDealerPaymentBlockUpdateRequest[]>(dealerBlock)
  }
}
